import Popover, { PopoverProps } from './Popover';

export default Popover;
export type { PopoverProps };
